var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.closeOpenList,
          expression: "closeOpenList"
        }
      ],
      staticClass: "toolbarTools"
    },
    _vm._l(_vm.visibleObjectOptions, function(item, index) {
      return _c(
        "v-layout",
        { key: item.layer },
        [
          _vm.standardItemPermissions(item)
            ? _c("standard-item", {
                attrs: {
                  label: item.label,
                  layer: item.layer,
                  icon: item.icon,
                  "filled-icon": item.filledIcon,
                  instructions: item.instructions
                },
                on: {
                  "select-item": function($event) {
                    return _vm.selectItem(item)
                  },
                  "reset-selected-item": _vm.resetSelectedItem
                }
              })
            : _c("item-with-options", {
                attrs: {
                  label: item.label,
                  "object-type": item.objectType,
                  "default-layer": item.defaultLayer,
                  options: item.options,
                  "open-list": _vm.openList
                },
                on: {
                  "select-item": _vm.selectItem,
                  "reset-selected-item": _vm.resetSelectedItem,
                  "toggle-options-menu": function($event) {
                    return _vm.toggleObjectOptionsList(item.objectType)
                  }
                }
              }),
          _vm._v(" "),
          index >= 0 && index < _vm.visibleObjectOptions.length - 1
            ? _c("v-divider", { attrs: { vertical: "" } })
            : _vm._e()
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d950465e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d950465e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Toolbars/CreateObjects/CreateObjectsToolbar.vue
// module id = null
// module chunks = 